import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isStrategy, setIsStrategy] = useState(false);
  const [isManualOrder, setIsManualOrder] = useState(false);
  const [isResults, setIsResults] = useState(false);
  const [iscurrentState, setIscurrentState] = useState('Dashboard');
  const [isAccount, setIsAccount] = useState(false);
  const [isCommunication, setIsCommunication] = useState(false);
  const [isIncentives, setIsIncentives] = useState(false);
  const [isCatalog, setIsCatalog] = useState(false);
  const [isWallets, setIsWallets] = useState(false);
  const [isLeadCapture, setIsLeadCapture] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [isCheckingAccount, setIsCheckingAccount] = useState(false);
  const [isImports, setIsImports] = useState(false);

  const authUser = JSON.parse(sessionStorage.getItem('authUser') ?? '{}');

  const isAdminOckCash =
    ['AdministradorOckCash', 'AdministradorOCKCash'].includes(authUser?.role?.name) ||
    authUser?.roles?.some((role) =>
      ['AdministradorOckCash', 'AdministradorOCKCash'].includes(role?.name)
    );

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute('subitems')) {
      const ul = document.getElementById('two-column-menu');
      const iconItems = ul.querySelectorAll('.nav-icon.active');
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove('active');
        let id = item.getAttribute('subitems');
        if (document.getElementById(id))
          document.getElementById(id).classList.remove('show');
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove('twocolumn-panel');
    if (iscurrentState !== 'Dashboard') {
      setIsDashboard(false);
    }

    if (iscurrentState !== 'Strategy') {
      setIsStrategy(false);
    }

    if (iscurrentState !== 'Results') {
      setIsResults(false);
    }

    if (iscurrentState !== 'ManualOrder') {
      setIsManualOrder(false);
    }

    if (iscurrentState !== 'Account') {
      setIsAccount(false);
    }

    if (iscurrentState !== 'Communication') {
      setIsCommunication(false);
    }

    if (iscurrentState !== 'Catalog') {
      setIsCatalog(false);
    }

    if (iscurrentState !== 'Reports') {
      setIsReport(false);
    }

    if (iscurrentState !== 'CheckingAccount') {
      setIsCheckingAccount(false);
    }

    if (iscurrentState !== 'Wallets') {
      setIsWallets(false);
    }

    if (iscurrentState !== 'LeadCapture') {
      setIsLeadCapture(false);
    }

    if (iscurrentState !== 'Imports') {
      setIsImports(false);
    }

  }, [
    history,
    iscurrentState,
    isDashboard,
    isStrategy,
    isManualOrder,
    isAccount,
    isCommunication,
    isResults,
    isWallets,
    isLeadCapture,
    isReport,
    isImports,
  ]);

  const menuItems = [
    {
      label: 'results',
      isHeader: true,
      permissions: ['one_page_report'],
    },
    {
      id: 'sales-summary',
      label: 'sales',
      icon: 'bx bx-bar-chart-alt-2',
      link: '/resultados/vendas',
      permissions: ['one_page_report'],
      click: function () {
        setIscurrentState('SalesSummary');
      },
    },
    // will be implemented on future
    // {
    //   id: "communication-summary",
    //   label: "communication",
    //   icon: 'bx bx-message-square-detail',
    //   link: "/resultados/comunicacoes",
    //   permissions: ["one_page_report"],
    //   click: function () {
    //     setIscurrentState('CommunicationSummary');
    //   },
    // },
    // {
    //   id: "credits-summary",
    //   label: "credits",
    //   icon: 'bx bx-credit-card',
    //   link: "/resultados/creditos",
    //   permissions: ["one_page_report"],
    //   click: function () {
    //     setIscurrentState('CreditsSummary');
    //   },
    // },

    {
      label: 'management',
      isHeader: true,
      permissions: [
        'sales_management',
        'customers',
        'catalog_strategies',
        'account_strategies',
        'catalog',
      ],
    },

    {
      id: 'customers',
      label: 'wallets.menu',
      icon: 'bx bx-wallet',
      link: '/carteiras',
      stateVariables: isWallets,
      permissions: ['customers', 'incentives'],
      click: () => setIscurrentState('Wallets'),
    },
    {
      id: 'sales_management',
      label: 'orders',
      icon: 'bx bx-cart',
      link: '/vendas',
      permissions: ['sales_management'],
      click: function (e) {
        setIscurrentState('Orders');
      },
    },

    {
      label: 'strategy-title-menu',
      isHeader: true,
      permissions: [
        'catalog_strategies',
        'account_strategies',
        'catalog',
        'incentives',
        'smart_incentive',
        'communications',
      ],
    },
    {
      id: 'strategies',
      label: 'strategy',
      icon: 'bx bx-git-merge',
      stateVariables: isStrategy,
      link: '/#',
      permissions: ['catalog_strategies', 'account_strategies'],
      click: function (e) {
        e.preventDefault();
        setIscurrentState('Strategy');
        setIsStrategy(!isStrategy);
      },
      subItems: [
        {
          id: 'account',
          label: 'general-strategy-by-account',
          link: '/estrategias/conta',
          permission: 'account_strategies',
          parentId: 'strategies',
        },
        {
          id: 'catalog',
          label: 'general-strategy-by-product',
          link: '/estrategias/catalogo',
          permission: 'catalog_strategies',
          parentId: 'strategies',
        },
        {
          id: 'campaigns',
          label: 'campaigns.title',
          link: '/estrategias/campanhas',
          permission: 'account_strategies',
          parentId: 'strategies',
        },
      ],
    },
    {
      id: 'incentives',
      label: 'incentives',
      icon: 'bx bx-gift',
      link: '/#',
      stateVariables: isIncentives,
      permissions: ['incentives', 'smart_incentive'],
      click: function (e) {
        e.preventDefault();
        setIscurrentState('Incentives');
        setIsIncentives(!isIncentives);
      },
      subItems: [
        {
          id: 'manual',
          label: 'manual',
          link: '/incentivos',
          permission: 'incentives',
          parentId: 'incentives',
        },
        {
          id: 'smart',
          label: 'smart',
          link: '/incentivos-inteligentes',
          permission: 'smart_incentive',
          parentId: 'incentives',
        },
      ],
    },
    {
      id: 'communications',
      label: 'communications',
      icon: 'bx bx-chat',
      link: '/#',
      stateVariables: isCommunication,
      permissions: ['communications'],
      click: function (e) {
        e.preventDefault();
        setIscurrentState('Communication');
        setIsCommunication(!isCommunication);
      },
      subItems: [
        {
          id: 'shupping-history',
          label: 'shipping-history',
          link: '/comunicacao/historico',
          permission: 'communications',
          parentId: 'communications',
        },
        {
          id: 'transactional',
          label: 'transactional-rule',
          link: '/comunicacao/transacional',
          permission: 'communications',
          parentId: 'communications',
        },
        {
          id: 'templates',
          label: 'communication-templates.menu',
          link: '/comunicacao/templates',
          permission: 'templates',
          parentId: 'communications',
        },
      ],
    },
    {
      label: 'tools',
      isHeader: true,
      permissions: ['orders', 'incentives', 'catalogs', 'lead_capture'],
    },
    {
      id: 'orders',
      label: 'manual-order',
      icon: 'bx bx-cart',
      link: '/vendas/novo',
      permissions: ['orders'],
      click: function () {
        setIscurrentState('ManualOrder');
      },
    },
    {
      id: 'catalog',
      label: 'catalog',
      icon: 'bx bx-purchase-tag',
      link: '/catalogo',
      stateVariables: isCatalog,
      permissions: ['catalogs'],
      click: function (e) {
        setIscurrentState('Catalog');
        setIsCatalog(!isCatalog);
      },
      subItems: [
        {
          id: 'catalog-blocked',
          label: 'catalog-blocked',
          link: '/catalogo/bloqueados',
          permission: 'catalogs',
          parentId: 'catalogs',
        },
      ],
    },
    {
      id: 'lead-capture',
      label: 'lead-capture.menu.parent',
      icon: 'bx bx-magnet',
      link: '/#',
      stateVariables: isLeadCapture,
      permissions: ['lead_capture'],
      click: function (e) {
        e.preventDefault();
        setIscurrentState('LeadCapture');
        setIsLeadCapture(!isLeadCapture);
      },
      subItems: [
        {
          id: 'lead-capture-dashboard',
          label: 'lead-capture.menu.dashboard',
          link: '/captura-de-leads',
          permission: 'lead_capture',
          parentId: 'lead-capture',
        },
        {
          id: 'lead-capture-settings',
          label: 'lead-capture.menu.settings',
          link: '/captura-de-leads/configuracao',
          permission: 'lead_capture',
          parentId: 'lead-capture',
        },
      ],
    },
    {
      id: 'my-wallet',
      label: 'my-wallet.menu',
      icon: 'bx bx-palette',
      link: '/minha-carteira',
      permissions: ['my_wallet'],
      click: function (e) {
        setIscurrentState('MyWallet');
      },
    },

    ...(isAdminOckCash
      ? [
        {
          label: 'ockcash',
          isHeader: true,
          permissions: ['one_page_report'],
        },
        {
          id: 'ockcash-dashboard',
          label: 'results',
          icon: 'bx bx-line-chart',
          link: '/ockcash/dashboard',
          permissions: ['one_page_report'],
          click: function () {
            setIscurrentState('OckCashDashboard');
          },
        },
        {
          id: 'transactions',
          label: 'transactions',
          icon: 'bx bx-money',
          link: '/ockcash/transacoes',
          permissions: ['account_transaction'],
          click: function () {
            setIscurrentState('Transactions');
          },
        },
        {
          id: 'carteira',
          label: 'carteira',
          icon: 'bx bx-wallet',
          link: '/ockcash/carteira',
          permissions: ['account_transaction'],
          click: function () {
            setIscurrentState('Carteira');
          },
        },
        {
          id: 'withdrawals',
          label: 'withdrawals.menu',
          icon: 'bx bx-money-withdraw',
          link: '/ockcash/retiradas',
          permissions: [],
          click: function () {
            setIscurrentState('Withdrawals');
          },
        },
      ]
      : []),

    {
      label: 'account',
      isHeader: true,
      permissions: [
        'account_users',
        'stores',
        'account_users',
        'general_settings',
        'integrations',
      ],
    },
    {
      id: 'account_users',
      label: 'users',
      icon: 'bx bx-user',
      link: '/conta/usuarios',
      permissions: ['account_users'],
      click: function () {
        setIscurrentState('AccountUsers');
      },
    },
    {
      id: 'audit',
      label: 'audit',
      icon: 'bx bx-clipboard',
      link: '/conta/auditoria',
      permissions: ['general_settings'],
      click: function () {
        setIscurrentState('Audit');
      },
    },
    {
      id: 'exportations',
      label: 'exportations.title',
      icon: 'bx bx-download',
      link: '/exportacoes',
      permissions: [],
      click: function () {
        setIscurrentState('Exportations');
      },
    },
    {
      id: 'imports',
      label: 'imports.title',
      icon: 'bx bx-upload',
      link: '/importacoes',
      permissions: [],
      click: function () {
        setIscurrentState('Imports');
      },
    },
    {
      id: 'stores',
      label: 'stores.menu',
      icon: 'bx bx-store',
      link: '/conta/lojas',
      permissions: ['stores'],
      click: function () {
        setIscurrentState('Stores');
      },
    },
    {
      id: 'permissions',
      label: 'permissions',
      icon: 'bx bx-lock',
      link: '/conta/permissoes',
      permissions: ['account_users'],
      click: function () {
        setIscurrentState('Permissions');
      },
    },
    {
      id: 'general-settings',
      label: 'general-settings.menu',
      icon: 'bx bx-cog',
      link: '/conta/configuracoes-gerais',
      permissions: ['general_settings'],
      click: function () {
        setIscurrentState('GeneralSettings');
      },
    },
    {
      id: 'integrations',
      label: 'integrations.menu',
      icon: 'bx bx-link-alt',
      link: '/integracoes',
      permissions: ['integrations'],
      click: function () {
        setIscurrentState('Integrations');
      },
    },
    {
      label: 'help',
      permissions: ['manual'],
      isHeader: true,
    },
    {
      id: 'manual',
      label: 'manual',
      icon: 'bx bx-help-circle',
      link: '/#',
      permissions: ['manual'],
      click: function (e) {
        setIscurrentState('Manual');
      },
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
